// extracted by mini-css-extract-plugin
export var breadCrumb = "newBreadcrumbs-module--breadCrumb--edb38";
export var breadCrumb__item = "newBreadcrumbs-module--breadCrumb__item--c440a";
export var breadCrumb__itemLink = "newBreadcrumbs-module--breadCrumb__itemLink--f8e4d";
export var breadCrumb__itemLinkLast = "newBreadcrumbs-module--breadCrumb__itemLinkLast--69f83";